package com.bikompanion.ui.models

/**
 * Where the post-parking pickup wait stands, for the screen to show.
 *
 * Bicing locks a bike to its dock for ten minutes after it's parked, so a rider who just voted
 * on one — voting only happens once it's already parked — can't grab another straight away.
 * Only Bicing enforces this, so every other network, and the time before any Bicing bike has
 * been voted on, is simply [Idle].
 */
sealed interface ParkingCountdownStatus {
    data object Idle : ParkingCountdownStatus

    data class Counting(
        val secondsRemaining: Int,
    ) : ParkingCountdownStatus
}
